import { tss } from "tss-react/mui";

export const useBlogHeroSectionStyles = tss.withName("BlogHeroSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[50],
        padding: "64px 4% 48px",
        textAlign: "center" as const,
    },
    container: {
        maxWidth: 720,
        margin: "0 auto",
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(2),
    },
}));
